import cn from 'classnames';
import { FC, ReactNode } from 'react';

import styles from './DocumentOffPanel.module.scss';

type Props = {
  children: ReactNode;
  title?: ReactNode;
  error?: ReactNode;
  className?: string;
};

export const DocumentOffPanel: FC<Props> = ({
  children,
  title,
  error,
  className,
}) => (
  <div className={cn(styles.panel, className)}>
    {title && <h3 className="h6">{title}</h3>}
    {children}
    {error && (
      <p role="alert" className={cn('p3', styles.alert)}>
        {error}
      </p>
    )}
  </div>
);
